import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TheNeed } from './components/TheNeed';
import { WhyCancun } from './components/WhyCancun';
import { OurVision } from './components/OurVision';
import { GlobalNetwork } from './components/GlobalNetwork';
import { WeddingEcosystem } from './components/WeddingEcosystem';
import { WeddingDateInquiry } from './components/WeddingDateInquiry';
import { WhatThisMakesPossible } from './components/WhatThisMakesPossible';
import { FundingPathways } from './components/FundingPathways';
import { FoundingCircle } from './components/FoundingCircle';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { LanguageProvider } from './lib/LanguageContext';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { PitchDeck } from './pages/PitchDeck';
function LandingPage() {
  return <>
      <Navbar data-id="element-0" />

      <main data-id="element-1">
        <Hero data-id="element-2" />
        <TheNeed data-id="element-3" />
        <WhyCancun data-id="element-4" />
        <OurVision data-id="element-5" />
        <GlobalNetwork data-id="element-6" />
        <WeddingEcosystem data-id="element-7" />
        <WeddingDateInquiry data-id="element-8" />
        <WhatThisMakesPossible data-id="element-9" />
        <FundingPathways data-id="element-10" />
        <FoundingCircle data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>

      <footer data-id="element-13">
        <FinalCTA data-id="element-14" />
      </footer>

      <StickyMobileCTA data-id="element-15" />
    </>;
}
export function App() {
  return <LanguageProvider data-id="element-16">
      <BrowserRouter data-id="element-17">
        <div className="min-h-screen bg-ivory font-sans text-navy antialiased selection:bg-saffron/30" data-id="element-18">
          <Routes data-id="element-19">
            <Route path="/" element={<LandingPage data-id="element-21" />} data-id="element-20" />
            <Route path="/pitch-deck" element={<PitchDeck data-id="element-23" />} data-id="element-22" />
          </Routes>
        </div>
      </BrowserRouter>
    </LanguageProvider>;
}